import { useContext } from "react";
import { z } from "zod";

import { LdoAuthContext } from "@nens/ldo/auth-v1";
import { useParsedQuery } from "@nens/react-query-utils";

import { API_BASE_URL } from "../constants";

export const frontendSettings = z.object({
  maptiler_api_key: z.string(),
});

export type FrontendSettings = z.infer<typeof frontendSettings>;

export function useFrontendSettings() {
  const { apiFetchFunction, tenantId } = useContext(LdoAuthContext);
  return useParsedQuery<FrontendSettings>(
    [tenantId, "ldo-api-v1", "frontend-settings"],
    () => apiFetchFunction(`${API_BASE_URL}/frontend-settings`),
    (json: unknown) => frontendSettings.parse(json)
  );
}
